import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// the translations
import commonEn from './en/common.json';
import authEn from './en/auth.json';
import validationEn from './en/validation.json';
import languageEn from './en/language.json';
import navEn from './en/nav.json';
import usersEn from './en/users.json';
import sitesEn from './en/sites.json';
import storagesEn from './en/storages.json';
import productsEn from './en/products.json';
import contactsEn from './en/contacts.json';
import productgroupsEn from './en/productgroups.json';
import applicationLinksEn from './en/applicationlinks.json';
import reportsEn from './en/reports.json';

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en: {
        common: commonEn,
        auth: authEn,
        validation: validationEn,
        language: languageEn,
        nav: navEn,
        users: usersEn,
        sites: sitesEn,
        storages: storagesEn,
        products: productsEn,
        contacts: contactsEn,
        productgroups: productgroupsEn,
        applicationlinks: applicationLinksEn,
        reports: reportsEn,
      },
    },
    lng: 'en',
    keySeparator: '.',
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
